import { JetView } from 'webix-jet'; // Importing JetView from webix-jet framework
import { allpayments } from 'models/allpayments'; // Importing allpayments model
import { devConfig } from 'config/config'; // Importing development configuration

/**
 * Class representing the view for auto-exclusion users table.
 */
export default class tableAutoexclusionUsersView extends JetView {
    /**
     * Configures the datatable for displaying auto-exclusion users.
     * @returns {Object} Configuration object for the datatable.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const dateFormat = webix.Date.dateToStr(this.app.config.dateFormat); // Date formatting function
        return {
            view: 'datatable', // Datatable view
            select: true, // Enable row selection
            columns: [
                // Column definitions
                { id: 'Id', header: 'Id', width: 100, sort: 'int' },
                {
                    id: 'PlayerId',
                    header: _('ID Usuario'), // Localized header
                    width: 100,
                    sort: 'int',
                },
                {
                    id: 'UserName',
                    header: _('Usuario (Correo electrónico)'), // Localized header
                    width: 250,
                    sort: 'int',
                },
                {
                    id: 'State',
                    header: _('Estado'), // Localized header
                    options: [
                        // Dropdown options for state
                        { id: '', value: _('None') },
                        { id: 'A', value: _('Activado') },
                        { id: 'C', value: _('Cancelado') },
                        { id: 'I', value: _('Inactivado') },
                    ],
                    width: 100,
                    sort: 'int',
                },
                {
                    id: 'Category',
                    header: _('Categorías'), // Localized header
                    width: 100,
                    sort: 'int',
                },
                {
                    id: 'SubCategory',
                    header: _('Sub Categoría'), // Localized header
                    width: 100,
                    sort: 'int',
                },
                { id: 'Game', header: _('Juego'), width: 100, sort: 'int' }, // Localized header
                {
                    id: 'FinalDate',
                    header: _('Fecha final de la autoexclusión'), // Localized header
                    fillspace: 0,
                    minWidth: 0,
                    width: 250,
                    sort: 'text',
                    format: dateFormat, // Date formatting
                },
                {
                    id: 'UserCreation',
                    header: _('Usuario Creación'), // Localized header
                    width: 200,
                    sort: 'int',
                },
                {
                    id: 'UserModified',
                    header: _('Usuario Modificó'), // Localized header
                    width: 200,
                    sort: 'int',
                },
            ],
            footer: true, // Enable footer
            math: true, // Enable math calculations in footer
            loadahead: devConfig.getDefaultDataFetch(), // Load ahead configuration
            loadahead: 5, // Number of records to load ahead
            pager: 'pagerA', // Pager ID
            // API endpoint for fetching data
            url: devConfig.geturlApi() + 'null/Report/getRegisteredAutoexclusion',
        };
    }

    /**
     * Initializes the grid and sets up event listeners.
     * @param {Object} grid - The datatable instance.
     */
    init(grid) {
        const _ = this.app.getService('locale')._; // Localization service
        const cur_user = this.getParam('user', true); // Current user ID
        var url = grid.data.url; // Data URL
        var filter = ''; // Filter string

        // Event listener for filtering data
        this.on(this.app, 'autoexclusionUsers:filter', (filterData) => {
            var object = Object.entries(filterData); // Convert filter data to entries
            var string1 = ''; // Filter string initialization
            for (var i = 0; i < object.length; i++) {
                if (typeof object[i][1] !== 'object' && object[i][1] !== '') {
                    if (object[i][0] == 'Datepicker') {
                        var date = object[i][1].split(' - '); // Split date range
                        console.log(date);
                        string1 = string1 + '&dateFrom=' + date[0]; // Add dateFrom to filter
                        string1 = string1 + '&dateTo=' + date[1]; // Add dateTo to filter
                    } else {
                        string1 = string1 + '&' + object[i][0] + '=' + object[i][1]; // Add other filters
                    }
                } else {
                    if (typeof object[i][1] === 'object') {
                        var object2 = Object.entries(object[i][1]); // Convert nested object to entries
                        for (var j = 0; j < object2.length; j++) {
                            if (object2[j][1] !== null) {
                                if (object2[j][0] === 'start') {
                                    var d = new Date(object2[j][1]); // Parse start date
                                    var dateFrom =
                                        'MaxCreatedLocal=' +
                                        d.getFullYear() +
                                        ':' +
                                        ('00' + (d.getMonth() + 1)).slice(-2) +
                                        ':' +
                                        ('00' + d.getDate()).slice(-2) +
                                        ' ' +
                                        ('00' + d.getHours()).slice(-2) +
                                        ':' +
                                        ('00' + d.getMinutes()).slice(-2) +
                                        ':' +
                                        ('00' + d.getSeconds()).slice(-2);
                                    string1 = string1 + '&' + dateFrom; // Add MaxCreatedLocal to filter
                                } else {
                                    if (object2[j][0] === 'end') {
                                        var d = new Date(object2[j][1]); // Parse end date
                                        var dateTo =
                                            'MinCreatedLocal=' +
                                            d.getFullYear() +
                                            ':' +
                                            ('00' + (d.getMonth() + 1)).slice(-2) +
                                            ':' +
                                            ('00' + d.getDate()).slice(-2) +
                                            ' ' +
                                            ('00' + d.getHours()).slice(-2) +
                                            ':' +
                                            ('00' + d.getMinutes()).slice(-2) +
                                            ':' +
                                            ('00' + d.getSeconds()).slice(-2);
                                        string1 = string1 + '&' + dateTo; // Add MinCreatedLocal to filter
                                    }
                                }
                            }
                        }
                    }
                }
            }
            string1 = string1 + '&FromId=' + cur_user; // Add current user to filter
            grid.clearAll(); // Clear existing grid data
            grid.load(url + '?start=0&count=' + grid.data.$pagesize + string1); // Load filtered data
            filter = string1; // Update filter variable
        });

        // Event listener for sorting data
        grid.attachEvent('onAfterSort', function (by, dir, as) {
            grid.load(
                url + '?start=0&count=' + grid.data.$pagesize + filter + '&sort[' + by + ']=' + dir, // Load sorted data
            );
        });

        // Event listener for row selection
        grid.attachEvent('onAfterSelect', (obj) => {
            this.app.callEvent('user:id', [obj.Id]); // Trigger user ID event
        });

        // Event listener before data is sent
        grid.attachEvent('onBeforeDataSend', function (send) {
            webix.message('Loading2...'); // Show loading message
        });

        // Event listener for data requests
        grid.attachEvent('onDataRequest', function (start, count) {
            custom_load(this.data.url, start, count); // Custom load function
            return true;
        });

        /**
         * Custom load function for fetching data.
         * @param {string} url - The URL to fetch data from.
         * @param {number} start - The starting index for data.
         * @param {number} count - The number of records to fetch.
         */
        function custom_load(url, start, count) {
            grid.load(
                url + '?start=' + start + '&count=' + count + '&FromId' + cur_user, // Load data with pagination
            );
        }

        // Event listener before loading data
        grid.attachEvent('onBeforeLoad', function () {
            webix.message('Loading...'); // Show loading message
            return true;
        });

        // Event listener for player selection
        this.on(this.app, 'player:select', (id) => {
            grid.load(
                grid.data.url + '?start=0&count=' + grid.data.$pagesize + '&FromId=' + id, // Load data based on selected player
            );
        });
    }
}

// FILE DOCUMENTED
